'use strict';

const $ = require('jquery');

class Waypoints {

    constructor() {

        let $block = $('.block, .keyvisual');

        if ($block.length > 0) {

            require('./../../../../build/node_modules/@components/waypoints/lib/jquery.waypoints.js');

            $block.waypoint(function (direction) {

                    let $el = $(this.element);

                    if (direction === 'down') {
                        $el.addClass('animate');
                    }

                },
                {
                    offset: '80%'
                });

        }

    }

}

module.exports = Waypoints;
